import React, { useState } from 'react'

export default function IEModal() {
  const [isShowing, setIsShowing] = useState(true)

  if (JSON.parse(sessionStorage.getItem('IE-NOTIFY')) && isShowing) {
    setIsShowing(false)
  }

  const closeModal = () => {
    sessionStorage.setItem('IE-NOTIFY', JSON.stringify(true))
    setIsShowing(false)
  }

  return isShowing ? (
    <>
      <div className="modal-overlay" />
      <div
        className="modal-wrapper"
        aria-modal
        aria-hidden
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal">
          <div className="u-flex u-flexAlignItemsCenter u-marginBottom5gu">
            <h3 className="u-flexAuto u-textSizeMsrp3">Browser notice</h3>
            <button
              type="button"
              onClick={closeModal}
              className="close-ie-notify u-textSizeMsrp2"
              role="button"
            >
              X
            </button>
          </div>
          <div className="u-marginBottom5gu">
            <p className="u-textBold u-marginBottom5gu">
              We noticed you&apos;re using Internet Explorer. We have
              discontinued support for this browser, which means this site may
              not display correctly. For an optimal experience, we recommend you
              download its replacement, Microsoft Edge.
            </p>
            <p className="u-textBold u-marginBottom5gu">
              A full list of browsers we support can be found on our{' '}
              <a href="/about-us/help/technical-support">
                Technical Support and Online Media FAQ
              </a>{' '}
              page.
            </p>
            <p>
              Visiting the links below will take you to the Microsoft website.
              This site is independent and not endorsed by Columbia Threadneedle
              Investments or its affiliates. Columbia Threadneedle Investments
              is not liable for any technical issues arising from your use of
              this site.
            </p>
          </div>
          <hr />
          <div className="u-marginTop5gu u-lg-flex u-lg-flexAlignItemsCenter">
            <a
              className="Button Button--primary u-flexAuto u-marginRight5gu u-sm-block u-sm-marginBottom5gu u-sm-marginLeft5gu"
              href="https://www.microsoft.com/en-us/edge"
            >
              Download Edge
            </a>
            <a
              className="u-textUppercase u-sm-block u-textCenter"
              href="https://support.microsoft.com/en-us/microsoft-edge/make-the-switch-from-internet-explorer-to-microsoft-edge-a6f7173e-e84a-36a3-9728-3df20ade9b3c"
            >
              Learn More About Edge
            </a>
          </div>
        </div>
      </div>
    </>
  ) : null
}
